import React from "react";
import SideBar from "../../components/Sidebar";
import { APP_INFO } from "../../constants/AppInfo";

const TermsAndConditions = () => {
  return (
    <div>
      <div className="container-fluid mt-3">
        <div className="row">
          {/* Sidebar */}
          <SideBar />

          {/* Main Content */}
          <div className="col-md-9 mb-3">
            <div className="card mb-4 shadow-sm">
              <div className="card-body">
                <h5 className="card-title">Terms and Conditions</h5>
                <div className="row">
                  <div className="container my-4">
                    <div className="row">
                      <div className="col-md-12">
                        <section>
                          <h6>1. Agreement to Terms</h6>
                          <p>
                            These Terms & Conditions ("Terms") are a legal
                            agreement between you ("User") and CHOTTU TELECOM,
                            the legal owner and operator of the brand{" "}
                            {APP_INFO.companyName}. By using our website, mobile
                            app, or services including recharge, bill payment,
                            or other utilities, you agree to be bound by these
                            Terms.
                          </p>
                          <p>
                            Our office is located at Barasat - 1, Kathuria,
                            Malikapur, Duttapukur, Barasat, North 24 Parganas,
                            West Bengal - 700126.
                          </p>

                          <h6>2. Eligibility</h6>
                          <p>
                            Our services are only available to individuals who
                            are at least 18 years of age and are capable of
                            entering into legally binding agreements.
                          </p>

                          <h6>3. Description of Services</h6>
                          <p>
                            {APP_INFO.companyName} offers the following
                            services:
                          </p>
                          <ul>
                            <li>Mobile Recharge (Prepaid & Postpaid)</li>
                            <li>DTH Recharge</li>
                            <li>
                              Utility Bill Payments (Electricity, Gas, Water,
                              etc.)
                            </li>
                            <li>Gift Vouchers and Digital Wallet Top-Ups</li>
                            <li>
                              <strong>Financial Services</strong>:
                              <ul>
                                <li>
                                  PPI Fund Transfers (In partnership with RBI
                                  licensed PPI issuer)
                                </li>
                                <li>
                                  PAN Card Services (via authorized partners
                                  like NSDL & UTI)
                                </li>
                              </ul>
                            </li>
                            <li>
                              <strong>Partnered Financial Services</strong>{" "}
                              (Under "Sell and Earn"):
                              <ul>
                                <li>
                                  Referral services for Savings Accounts, Demat
                                  Accounts, and Credit Cards with partnered
                                  institutions.
                                </li>
                                <li>
                                  Facilitation of connections with licensed
                                  Insurance POSP (Point of Sales Person) agents.
                                </li>
                              </ul>
                            </li>
                            <li>
                              Other Digital Services as introduced from time to
                              time
                            </li>
                          </ul>
                          <p>
                            <strong>
                              Important Note on Third-Party Services:
                            </strong>{" "}
                            For Financial, PAN, Insurance, and Referral
                            services, {APP_INFO.companyName} acts solely as a
                            facilitator/platform. The end service is provided by
                            third-party institutions, and your contractual
                            relationship is with them. We are not responsible
                            for their service quality, delays, or disputes.
                          </p>
                          <p>
                            All services are subject to availability. We reserve
                            the right to update, remove, or suspend any service
                            without prior notice.
                          </p>
                          <h6>4. User Obligations</h6>
                          <p>As a user, you agree to:</p>
                          <ul>
                            <li>
                              Provide accurate, complete, and updated
                              information
                            </li>
                            <li>
                              Verify recharge details before confirming any
                              transaction
                            </li>
                            <li>
                              Keep your account credentials secure and
                              confidential
                            </li>
                            <li>
                              Use the platform only for lawful and personal
                              purposes
                            </li>
                          </ul>

                          <h6>5. Payments and Fees</h6>
                          <p>
                            We accept payments via multiple methods including
                            UPI, Net Banking, Cards, and Wallets. All charges
                            are in INR.
                          </p>
                          <p>
                            {APP_INFO.companyName} or CHOTTU TELECOM may apply
                            convenience fees, gateway charges, or
                            commission-based deductions which will be shown
                            transparently before payment.
                          </p>

                          <h6>6. Prohibited Activities</h6>
                          <p>
                            Users agree not to engage in any of the following
                            activities:
                          </p>
                          <ul>
                            <li>
                              Any illegal, unlawful, fraudulent, misleading, or
                              unauthorized use of the platform or its services
                            </li>
                            <li>
                              Use of automated systems, bots, scripts, or any
                              other means to access, extract data from, or
                              interact with the services without prior written
                              authorization
                            </li>
                            <li>
                              Attempting to gain unauthorized access to,
                              interfere with, damage, disrupt, or compromise the
                              integrity, security, or performance of the
                              application, servers, networks, or related systems
                            </li>
                            <li>
                              Impersonating any person or entity,
                              misrepresenting identity, or providing false,
                              inaccurate, or misleading information
                            </li>
                            <li>
                              Engaging in resale, redistribution, or commercial
                              exploitation of the services without prior written
                              approval from CHOTTU TELECOM and
                              {APP_INFO.companyName}
                            </li>
                            <li>
                              Using the platform for activities that violate
                              applicable laws, regulatory guidelines,
                              third-party rights, or public order
                            </li>
                          </ul>

                          <h6>7. Intellectual Property</h6>
                          <p>
                            All logos, trademarks, brand names, content, and
                            software on {APP_INFO.companyName} are the
                            intellectual property of CHOTTU TELECOM or its
                            partners. Unauthorized reproduction or usage is
                            strictly prohibited.
                          </p>

                          <h6>8. Refunds & Cancellations</h6>
                          <p>
                            All recharge and bill payment transactions, once
                            successfully processed, are final and cannot be
                            cancelled or reversed.
                          </p>
                          <p>
                            In the event of a failed, pending, or incomplete
                            transaction where the amount has been debited but
                            the service has not been delivered, the refund (if
                            applicable) shall be processed in accordance with
                            our Refund Policy and applicable regulatory
                            guidelines.
                          </p>
                          <p>
                            Refunds, where approved, will be credited back to
                            the original source of payment or adjusted within
                            the user account within the prescribed timeline,
                            subject to verification and confirmation from
                            relevant service providers or payment partners.
                          </p>
                          <p>
                            CHOTTU TELECOM and {APP_INFO.companyName} shall not
                            be responsible for delays caused by banks, payment
                            networks, or third-party service providers involved
                            in processing the transaction.
                          </p>

                          <h6>9. Privacy Policy</h6>
                          <p>
                            Your use of our services is also governed by our
                            Privacy Policy, which explains how we collect,
                            store, and handle your personal data.
                          </p>

                          <h6>10. Disclaimers</h6>
                          <p>
                            While we strive for accuracy and reliability, we do
                            not guarantee uninterrupted or error-free services.
                            The use of our platform is at your own risk.
                          </p>
                          <p>
                            We are not responsible for issues arising from
                            third-party service providers (telecom, electricity
                            boards, banks, etc.).
                          </p>

                          <h6>11. Limitation of Liability</h6>
                          <p>
                            To the maximum extent permitted by applicable law,
                            CHOTTU TELECOM and
                            {APP_INFO.companyName}, including their directors,
                            employees, affiliates, partners, and service
                            providers, shall not be liable for any direct,
                            indirect, incidental, special, consequential, or
                            punitive damages arising out of or related to your
                            access to, use of, or inability to use the services.
                          </p>
                          <p>
                            This includes, but is not limited to, loss of
                            profits, loss of data, business interruption,
                            unauthorized access, system downtime, transaction
                            delays, failures caused by third-party service
                            providers, network issues, technical errors, or
                            events beyond reasonable control.
                          </p>
                          <p>
                            CHOTTU TELECOM and {APP_INFO.companyName} do not
                            guarantee uninterrupted or error-free service and
                            shall not be responsible for any losses resulting
                            from reliance on information, transactions, or
                            services provided through the platform.
                          </p>
                          <p>
                            In no event shall the total liability of CHOTTU
                            TELECOM and
                            {APP_INFO.companyName} exceed the amount paid by the
                            user for the specific service giving rise to the
                            claim, if any, during the preceding three (3)
                            months.
                          </p>
                          <p>
                            Some jurisdictions do not allow the exclusion or
                            limitation of certain damages. In such cases,
                            liability shall be limited to the fullest extent
                            permitted by applicable law.
                          </p>

                          <p>
                            Our liability in any event will be limited to the
                            amount paid by you for the disputed transaction.
                          </p>

                          <h6>12. Amendments</h6>
                          <p>
                            We reserve the right to amend these Terms at any
                            time. Updated versions will be posted on the
                            website. Continued use after updates means you
                            accept the revised Terms.
                          </p>

                          <h6>13. Governing Law & Jurisdiction</h6>
                          <p>
                            These Terms and Conditions shall be governed by and
                            construed in accordance with the laws of India,
                            without regard to its conflict of law principles.
                          </p>
                          <p>
                            Any dispute, claim, or controversy arising out of or
                            relating to these Terms, the use of the application,
                            or the services provided shall be subject to the
                            exclusive jurisdiction of the competent courts
                            located in Kolkata, West Bengal, India.
                          </p>
                          <p>
                            The user expressly agrees to submit to such
                            jurisdiction and waives any objection regarding
                            venue or forum on the grounds of inconvenience or
                            otherwise.
                          </p>

                          <h6>14. Contact Us</h6>
                          <p>
                            For any queries or support related to these Terms,
                            you may contact us at:
                          </p>
                          <p>
                            CHOTTU TELECOM ({APP_INFO.companyName})<br />
                            Barasat - 1, Kathuria, Malikapur, Duttapukur
                            <br />
                            Barasat, North 24 Parganas, West Bengal - 700126
                            <br />
                            Email: {APP_INFO.email}
                          </p>
                        </section>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;
